import { useLang } from 'hooks/lang';

import { PropertyWithIcon } from 'components/PropertyWithIcon';
import { DollarBillIcon, HandCoinsIcon, UserSquareIcon } from 'components/Icons';

import { formatCurrency } from 'utils/text';

interface PackageDataProps {
  data: {
    amountAvailable: string;
    currency: string;
    value: string;
    clientName: string;
  };
}

export function PackageData({ data }: PackageDataProps) {
  const { t } = useLang();

  return (
    <>
      <PropertyWithIcon icon={<UserSquareIcon />} name={t('client')} value={data.clientName} />
      <PropertyWithIcon
        icon={<DollarBillIcon />}
        name={t('total')}
        value={formatCurrency(data.value, data.currency)}
      />
      <PropertyWithIcon
        icon={<HandCoinsIcon />}
        name={t('available')}
        value={formatCurrency(data.amountAvailable, data.currency)}
      />
    </>
  );
}
